import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { Checkbox } from 'primeng/checkbox';

@Component({
  selector: 'formly-geaui-checkbox-v3',
  imports: [ReactiveFormsModule, FormlyModule, TranslateModule, Checkbox],
  template: `
    <section class="geaui-checkbox">
      <p-checkbox [binary]="true" [formControl]="formControl" [formlyAttributes]="field" [inputId]="id"></p-checkbox>
      @if (props.label) {
        <label class="checkbox-label" [class.disabled]="formControl.disabled" [for]="id">
          {{ props.label | translate }}
        </label>
      }
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeaUiCheckboxV3TypeComponent extends FieldType<FieldTypeConfig> {}
